module.exports = __webpack_public_path__ + "img/jsfiddle.b0fc9a79.svg";